module.exports = __webpack_public_path__ + "img/rep-kayla.991250de.png";